import { Button } from '@mui/material';
import { capitalizeFirstLetter } from '../../../../services/string';
import * as React from 'react';

export default function StageButton({ bidding }) {
  return (
    <Button variant={`bidding-${bidding.stage}`}>{capitalizeFirstLetter(bidding.stage)}</Button>
  );
}
